import { Controller } from "@hotwired/stimulus"

// Presenter step coordinator for the music-theory wizard:
//   * toggleChoice — "No presenter" disables the presenter fieldset (disabled
//     inputs drop out of both the PATCH save and the live-preview FormData,
//     so the preview drops the presenter immediately).
//   * filterClips — the character <select> shows only that character's clip
//     group and syncs the generate-line form's hidden character_id.
//   * estimate — display-only cost readout for "Generate new line", computed
//     from the rates the component passes (single-sourced from the Ruby
//     constants the budget guard uses). Nothing generates from here — the
//     POST button is the only trigger.
//
// Live-preview refresh itself stays in music_theory_preview_controller — all
// presenter inputs are named under the template prefix it already watches.
export default class extends Controller {
  static targets = [
    "presenterFields", "characterSelect", "clipGroup",
    "generateCharacterId", "phraseInput", "costOutput",
  ]
  static values = { rates: Object }

  connect() {
    this.filterClips()
    this.estimate()
  }

  toggleChoice(event) {
    const showPresenter = event.target.value === "clip"
    if (this.hasPresenterFieldsTarget) {
      this.presenterFieldsTarget.disabled = !showPresenter
    }
  }

  filterClips() {
    if (!this.hasCharacterSelectTarget) return
    const characterId = this.characterSelectTarget.value
    this.clipGroupTargets.forEach((group) => {
      group.hidden = group.dataset.characterId !== characterId
    })
    if (this.hasGenerateCharacterIdTarget) {
      this.generateCharacterIdTarget.value = characterId
    }
  }

  estimate() {
    if (!this.hasPhraseInputTarget || !this.hasCostOutputTarget) return
    const r = this.ratesValue
    const words = this.phraseInputTarget.value.trim().split(/\s+/).filter(Boolean).length
    const speech = Math.max(words * r.secondsPerWord, r.minSpeechSeconds)
    const duration = Math.min(
      Math.max(Math.ceil(speech + r.leadInSeconds + r.tailBufferSeconds), r.minDurationSeconds),
      r.maxDurationSeconds
    )
    const total = duration * r.perSecond + r.imageFee + r.stsFee
    this.costOutputTarget.textContent = `$${total.toFixed(2)} (~${duration}s clip)`
  }
}
